import React, { useEffect, useState } from "react";
import Loading from "../../shared/Loading";

const CheckOutCard1 = ({ data, discount }) => {
  // getting props
  const [price, setPrice] = useState(data?.productId?.unit_price);
  const [q, setQ] = useState(data?.quantity);

  useEffect(() => {
    if (discount?.category?.includes(data?.productId?.categories[0]))
      setPrice(
        data?.productId?.unit_price -
          (data?.productId?.unit_price * discount?.value) / 100
      );
  }, [data?.productId, discount]);

  if (!data?.productId || !discount) <Loading></Loading>;
  return (
    data?.productId &&
    discount && (
      <div className="flex p-4 px-6 justify-between gap-3 items-start border border-gray-300 text-xs">
        {/* details & quantity incre  */}
        <div className="flex">
          <img className="w-16 rounded-lg" src={data?.productId?.img} alt="" />
          <div className="ml-4">
            <p>Name: {data?.productId?.title}</p>
            <p>Unit Price: BDT {price}</p>
          </div>
        </div>
        {/* price & btn */}
        <div>
          <p className="">Total Price: BDT{price * q}</p>
          <p>Quantity: {q}</p>
        </div>
      </div>
    )
  );
};

export default CheckOutCard1;
